import axios from 'axios';
import Constant from '../Constant';
import {
  SET_LOADING,
  LOGOUT,
  ADMIN_REGISTER,
  SET_USER,
  GET_COUNTRY,
  GET_DATA_COUNTS,
  GET_ALL_USER,
  GET_CATEGORY,
  GET_GOVERNORATE,
  GET_AREA,
  GET_TERMS,
  GET_TAXI_DATA,
  GET_CAR_TOWING_DATA,
  GET_SPARE_PART_DATA,
  GET_CAR_DEALER_DATA,
  GET_CAR_SALE_DATA,
  GET_CAR_RENT_DATA,
  GET_SINGLE_TAXI_OWNER_DATA,
  GET_SINGLE_CAR_TOWING_OWNER_DATA,
  GET_SERVICE_FILTER,
  GET_GARAGE_DATA,
  GET_BUSINESS_DATA,
  GET_CARBRAND_DATA,
  GET_ALL_PRODUCT_PARTS_DATA,
  GET_ALL_PARTS_DATA,
  GET_GARAGE_CATEGORY,
  GET_CAR_DEALER_CATEGORY,
  GET_SPARE_PART_CATEGORY,
  GET_ADMIN_AREA,
  GET_ALL_BUSINESS_DATA_LIST,
  GET_ALL_BUSINESS_CATEGORY,
  GET_SERVICES_DATA,
  ADD_CAR_SERVICES,
  ADD_QUICK_SERVICES,
  GET_PACKAGES_LIST,
  GET_USER_LIST,
  UPDATE_USER_PROFILE,
  GET_SINGLE_GARAGE_OWNER,
  GET_SINGLE_SPARE_PART,
  UPDATE_SINGLE_SPARE_PART,
  GET_COUNTRIES_LIST,
  GET_CYCLINDER_LIST,
  GET_MODEL_YEAR_LIST,
  GET_FUEL_TYPE_LIST,
  GET_SEATS_LIST,
  GET_DOOR_LIST,
  GET_COLOR_LIST,
  GET_SAFETY_LIST,
  GET_COMFORT_LIST,
  ADD_COMFORT,
  GET_SINGLE_COMFORT_LIST,
  GET_SINGLE_SAFETY_LIST,
  ADD_SAFETY_LIST,
  ADD_COLOR_LIST,
  ADD_SEAT_LIST,
  ADD_DOOR_LIST,
  ADD_FUEL_TYPE,
  ADD_MODEL_YEAR,
  ADD_CYLINDER,
  GET_SINGLE_COLOR_LIST,
  GET_SINGLE_SEAT_LIST,
  GET_SINGLE_DOOR_LIST,
  GET_SINGLE_FUEL_TYPE_LIST,
  GET_SINGLE_MODEL_YEAR_LIST,
  GET_SINGLE_CYCLINDER_LIST,
  UPDATE_COMFORT,
  UPDATE_SAFETY_LIST,
  UPDATE_COLOR_LIST,
  UPDATE_SEAT_LIST,
  UPDATE_DOOR_LIST,
  UPDATE_FUEL_TYPE,
  UPDATE_MODEL_YEAR,
  UPDATE_CYLINDER,
  GET_SINGLE_CAR_BRAND,
  GET_SINGLE_PRODUCT_PART_DATA,
  GET_SERVICE_PROVIDER_LIST,
  UPDATE_SERVICES_DATA,
  GET_SINGLE_SERVICES_DATA,
  GET_SINGLE_QUICK_SERVICE,
  UPDATE_GARAGE_CATEGORY,
  GET_SINGLE_GARAGE_CATEGORY,
  GET_SINGLE_SPARE_PART_CATEGORY,
  GET_SINGLE_CAR_DEALER,
  GET_SINGLE_CAR_DEALER_CATEGORY,
  GET_SINGLE_CAR_WASH_CATEGORY,
  GET_SINGLE_CAR_INSURANCE_CATEGORY,
  GET_SINGLE_CAR_PROTECTION_CATEGORY,
  GET_SINGLE_AIR_CONDITION_CATEGORY,
  ADD_TERMS_AND_CONDITION,
  GET_CARBRAND_FILTER,
  ADD_PACKAGES_LIST,
  UPDATE_PACKAGES_LIST,
  GET_SINGLE_CAR_DEALER_DATA,
  GET_SINGLE_CAR_RENT_DATA,
  GET_SINGLE_CAR_SALE_DATA,
  SEND_NOTIFICATION,
  GET_CARMODEL_DATA,
  CONTACT_LIST,
  SINGLE_AREA,
  GET_DATEWISE_ORDER,
  GET_SINGLE_CAR_WASH,
  GET_SINGLE_CAR_INSURANCE,
  GET_SINGLE_DRIVING_SCHOOL,
  GET_SINGLE_DRIVING_SCHOOL_CATEGORY,
  GET_SINGLE_CAR_PROTECTION,
  GET_SINGLE_AIR_CONDITIONING,
  GET_SINGLE_QUICK_SERVICE_OWNER,
  GET_CUSTOM_DATA_COUNTS,
} from './types';
import Swal from 'sweetalert2';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('loged_In_auth'),
  },
};
var configuser = {
  headers: {
    'Content-Type': 'application/json',
    Authorization:
      'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJjMzBlZWRlNi01MGI1LTRiOTYtOGFlZC0yZDA5MTk0NGUyNjMiLCJpYXQiOjE2MjY2Nzk0OTh9.znCD1cz8-GNGUjQpt4ixE8XLHswg4PBNU2Hm4M9CPZU',
  },
};
// SET LOADING
export const setLoading = (data) => (dispatch) => {
  dispatch({
    type: SET_LOADING,
    payload: data,
  });
};

// ADMIN LOGIN
export const loginUser = (data) => (dispatch) => {
  try {
    console.log('hd>>>>', data);
    axios

      .post(Constant.getAPI() + '/admin/login', data)

      .then((res) => {
        console.log('heeee<<<<', res);
        dispatch({
          type: SET_USER,
          payload: res.data,
        });
        console.log('woooo coool', res.data);

        console.log('heeee<<<<', res);

        Swal.fire({
          title: 'Login Successfully',
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        });

        localStorage.setItem('loged_In_auth', res.data.response.authToken);
        localStorage.setItem('ucs-adminId', res.data.response.adminId);

        localStorage.setItem('loged_In', true);
        window.location.href = '#/';
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: 'Enter the valid username or password',
          icon: 'error',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        });
      });
  } catch (err) {
    Swal.fire('Incorrect Credentials', '', 'error');
  }
};

// LOGOUT
export const logout = () => (dispatch) => {
  dispatch({
    type: LOGOUT,
    payload: {},
  });
  localStorage.clear();
  window.location.href = '#/';
  window.location.reload();
};

// Register Admin

export const AdminRegister = (admin) => (dispatch) => {
  try {
    console.log('hd>>>>', admin);
    axios

      .post(Constant.getAPI() + '/admin/register', admin)

      .then((res) => {
        console.log('heeee<<<<', res);
        dispatch({
          type: ADMIN_REGISTER,
          payload: res.data.response,
        });

        console.log('response', res.data.response);

        console.log('data is here<<<<', res);

        Swal.fire({
          title: 'Register Successfully',
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        });

        localStorage.setItem('OtpId', res.data.response.otpId);
        localStorage.setItem('isActive', res.data.response.isActive);
        localStorage.setItem('otp', res.data.response.otp);

        window.location.href = '#/OtpVerification';

        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: 'Registeration faild please try again!!!',
          icon: 'error',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        });
      });
  } catch (err) {
    Swal.fire('Incorrect Credentials', '', 'error');
  }
};

// var data = new URLSearchParams();

//GET COUNTS DATA
export const getDataCounts = (data) => (dispatch) => {
  var data = new URLSearchParams();

  axios
    .get(
      Constant.getAPI() + '/admin/dashboard/counts',

      config
    )
    .then((res) => {
      dispatch({
        type: GET_DATA_COUNTS,
        payload: res.data.response,
      });
      console.log('ress>>', res.data.response);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSalesAndOrdersByDateRange = (data) => (dispatch) => {
  axios
    .get(
      Constant.getAPI() +
        '/admin/dashboard/custom-counts?startDate=' +
        data.startDate +
        '&endDate=' +
        data.endDate,

      config
    )
    .then((res) => {
      dispatch({
        type: GET_CUSTOM_DATA_COUNTS,
        payload: res.data.response,
      });
      console.log('ress>>', res.data.response);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

//GET GARAGE DATA

export const getGarageData = (data) => (dispatch) => {
  var data = new URLSearchParams();

  axios
    .get(
      Constant.getAPI() + `/garageOwner/listing`,

      config
    )
    .then((res) => {
      dispatch({
        type: GET_GARAGE_DATA,
        payload: res.data.response,
      });
      console.log('ress>>', res.data.response);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};
//GET ALL USER DATA

export const getallUser =
  (serviceType, userType, RegDate, statusType) => (dispatch) => {
    console.log('API call triggered with filters:', {
      serviceType,
      userType,
      RegDate,
      statusType,
    });

    // Build the query object dynamically
    const queryObject = {};

    if (RegDate && RegDate.trim() !== '') {
      queryObject.createdAt = RegDate.trim();
    }

    if (statusType && statusType.trim() !== '') {
      queryObject.status = statusType.trim();
    }

    if (userType && userType.trim() !== '') {
      queryObject.userType = userType.trim();
    }

    if (serviceType && serviceType.trim() !== '') {
      queryObject.serviceType = serviceType.trim();
    }

    // Build query string from object
    const queryString = new URLSearchParams(queryObject).toString();
    const url = `${Constant.getAPI()}/user${
      queryString ? '?' + queryString : ''
    }`;

    axios
      .get(url, config)
      .then((res) => {
        dispatch({
          type: GET_ALL_USER,
          payload: res.data,
        });
        console.log('ress>>', res);
        dispatch(setLoading(true));
      })
      .catch((err) => console.log(err));
  };

//GET cAR DEALER DATA

export const getcardealerListing = () => (dispatch) => {
  // console.log('this is inside axios cardealer', data);

  axios
    .get(Constant.getAPI() + '/carDealer/listing', config)
    .then((res) => {
      dispatch({
        type: GET_CAR_DEALER_DATA,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSingleCarDealer = (data) => (dispatch) => {
  // console.log('this is inside axios cardealer', data);

  axios
    .get(Constant.getAPI() + `/carDealer/listing?carDealerId=${data}`, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      dispatch({
        type: GET_SINGLE_CAR_DEALER_DATA,
        payload: res.data.response,
      });
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const updateCarDealer = (data) => (dispatch) => {
  // console.log('this is inside axios cardealer', data);
  dispatch(setLoading(true));
  axios
    .put(Constant.getAPI() + `/carDealer/listing`, data, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      // dispatch({
      // 	type: GET_SINGLE_CAR_DEALER_DATA,
      // 	payload: res.data.response,
      // });
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '#/ServiceProviders/CarDealers';
    })
    .catch((err) => console.log(err));
};

//GET bUSINESS lISTING

export const getBusinessListing = () => (dispatch) => {
  console.log('this is inside axios get business listing ');

  axios
    .get(Constant.getAPI() + '/business/listing', config)
    .then((res) => {
      dispatch({
        type: GET_BUSINESS_DATA,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};
//GET CAR SALE DATA
export const getcarsaleListing = () => (dispatch) => {
  axios
    .get(Constant.getAPI() + '/carSale/listing', config)
    .then((res) => {
      dispatch({
        type: GET_CAR_SALE_DATA,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSingleCarSale = (id) => (dispatch) => {
  axios
    .get(Constant.getAPI() + `/carSale/listing?carSaleId=${id}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_CAR_SALE_DATA,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const updateCarForSale = (data) => (dispatch) => {
  axios
    .put(Constant.getAPI() + '/carSale/listing', data, config)
    .then((res) => {
      console.log(res);
      dispatch(setLoading(true));
      window.location.href = '#/ServiceProviders/CarForSale';
    })
    .catch((err) => console.log(err));
};
//GET CAR RENT DATA
export const getCarRentListing = () => (dispatch) => {
  axios
    .get(Constant.getAPI() + '/carRent/listing', config)
    .then((res) => {
      dispatch({
        type: GET_CAR_RENT_DATA,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSingleCarRent = (data) => (dispatch) => {
  // console.log('this is inside axios cardealer', data);

  axios
    .get(Constant.getAPI() + `/carRent/listing?carRentId=${data}`, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      dispatch({
        type: GET_SINGLE_CAR_RENT_DATA,
        payload: res.data.response,
      });
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const updateCarRent = (data) => (dispatch) => {
  console.log('this is inside axios carrent', data);
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/carRent/listing`, data, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      // dispatch({
      // 	type: GET_SINGLE_CAR_DEALER_DATA,
      // 	payload: res.data.response,
      // });
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '#/ServiceProviders/RentCar';
    })
    .catch((err) => console.log(err));
};

//GET SPARE PART DATA
export const SparePartsGetList = () => (dispatch) => {
  console.log('this is inside axios');

  axios
    .get(Constant.getAPI() + '/spareParts/listing', config)
    .then((res) => {
      dispatch({
        type: GET_SPARE_PART_DATA,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};
//GET TAXI DATA
export const getTaxiData = () => (dispatch) => {
  console.log('this is inside axios  taxi');

  axios
    .get(
      Constant.getAPI() + '/taxiOwner/listing',

      config
    )
    .then((res) => {
      dispatch({
        type: GET_TAXI_DATA,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSingleTaxiOwner = (data) => (dispatch) => {
  // console.log('this is inside axios taxiowner', data);

  axios
    .get(Constant.getAPI() + `/taxiOwner/listing?taxiOwnerId=${data}`, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      dispatch({
        type: GET_SINGLE_TAXI_OWNER_DATA,
        payload: res.data.response,
      });
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const updateTaxiOwner = (data) => (dispatch) => {
  console.log('this is inside axios carrent', data);
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/taxiOwner/listing`, data, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      // dispatch({
      // 	type: GET_SINGLE_CAR_DEALER_DATA,
      // 	payload: res.data.response,
      // });
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '#/ServiceProviders/Taxi';
    })
    .catch((err) => console.log(err));
};

//GET TOWING DATA
export const getCarTowingData = () => (dispatch) => {
  console.log('this is inside axios  towing');

  axios
    .get(
      Constant.getAPI() + '/towingOwner/listing',

      config
    )
    .then((res) => {
      dispatch({
        type: GET_CAR_TOWING_DATA,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSingleCarTowingOwner = (data) => (dispatch) => {
  // console.log('this is inside axios taxiowner', data);

  axios
    .get(
      Constant.getAPI() + `/towingOwner/listing?towingOwnerId=${data}`,
      config
    )
    .then((res) => {
      console.log('78ad8a7d8', res);
      dispatch({
        type: GET_SINGLE_CAR_TOWING_OWNER_DATA,
        payload: res.data.response,
      });
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const updateTowingOwner = (data) => (dispatch) => {
  console.log('this is inside axios carrent', data);
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/towingOwner/listing`, data, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      // dispatch({
      // 	type: GET_SINGLE_CAR_DEALER_DATA,
      // 	payload: res.data.response,
      // });
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '#/ServiceProviders/CarTowing';
    })
    .catch((err) => console.log(err));
};

// CATEGORY LIST
export const getCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post(Constant.getAPI() + '/category/get', config)
    .then((res) => {
      console.log(res.data);
      dispatch({
        type: GET_CATEGORY,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

// ADD CATEGORY
export const addCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post(Constant.getAPI() + '/category/add', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Category added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/category';
      dispatch(getCategory());
    })
    .catch((err) => console.log(err));
};

//DELETE CATEGORY
export const deleteCategory = (data) => (dispatch) => {
  //console.log(data)

  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .post(Constant.getAPI() + '/category/delete', data, config)
        .then((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'You will not be able to recover this !',
            imageUrl: './assets/images/test.png',
            imageHeight: 100,
            type: 'warning',
          });
          window.location.reload();
          dispatch(getCategory());
        })
        .catch((err) => console.log(err));
    }
  });
};

//update category
export const updateCategory = (data) => (dispatch) => {
  console.log(data);
  axios

    .post(Constant.getAPI() + `/category/edit`, data, config)
    .then((res) => {
      console.log(res.data);
      Swal.fire({
        title: 'Category Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getCategory());
      window.location.href = '#/category';
    })
    .catch((err) => console.log(err));
};

// COUNTRY LIST
export const getCountry = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get('https://caravenue.infoware.xyz/api/user', config)
    .then((res) => {
      dispatch({
        type: GET_COUNTRY,
        payload: res,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};
//ADD COUNTRY
export const addCountry = (data) => (dispatch) => {
  console.log(config);
  axios
    .post(Constant.getAPI() + `/country/add`, data.payload, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Country added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getCountry());
      window.location.href = '#/country';
    })
    .catch((err) => console.log(err));
};
//UPDATE COUNTRY
export const updateCountry = (data) => (dispatch) => {
  console.log(data);
  axios

    .post(Constant.getAPI() + `/country/edit`, data, config)
    .then((res) => {
      console.log(res.data);
      Swal.fire({
        title: 'Country Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getCountry());
      window.location.href = '#/country';
    })
    .catch((err) => console.log(err));
};

//COUNTRY DELETE
export const deleteCountry = (data) => (dispatch) => {
  //console.log(data)

  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    imageUrl: './assets/images/test.png',
    imageHeight: 100,
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .post(Constant.getAPI() + '/country/delete', data, config)
        .then((res) => {
          Swal.fire({
            title: 'Country Deleted',
            text: 'You will not be able to recover this !',
            type: 'warning',
            imageUrl: './assets/images/test.png',
            imageHeight: 100,
            // showCancelButton: true,
            // confirmButtonText: "Yes, delete it!",
            // cancelButtonText: "No, keep it",
          });
          dispatch(getCountry());
          window.location.href = '#/country';
        })
        .catch((err) => console.log(err));
    }
  });
};

// GOVERNORATE LIST
export const getGovernorate = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + '/governorate/get', data, config)
    .then((res) => {
      dispatch({
        type: GET_GOVERNORATE,
        payload: res.data.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};
// DELETE GOVERNORATE
export const deleteGovernorate = (data) => (dispatch) => {
  console.log(data);

  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    imageUrl: './assets/images/test.png',
    imageHeight: 100,
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((Confirm) => {
    if (Confirm.value) {
      axios
        .post(Constant.getAPI() + '/governorate/delete', data, config)
        .then((res) => {
          Swal.fire({
            title: 'Governorate Deleted',
            imageUrl: './assets/images/test.png',
            imageHeight: 100,
            text: 'You will not be able to recover this !',
            imageUrl: './assets/images/test.png',
            imageHeight: 100,
            type: 'warning',
          });
          dispatch(getGovernorate());
          window.location.href = '#/governorate';
        })
        .catch((err) => console.log(err));
    }
  });
};
//ADD GOVERNORATE
export const addGovernorate = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + '/governorate/add', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Governorate added',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getGovernorate());
      window.location.href = '#/governorate';
    })
    .catch((err) => console.log(err));
};
//UPDATE GOVERNORATE
export const updateGovernorate = (data) => (dispatch) => {
  console.log(data);
  axios
    .post(Constant.getAPI() + '/governorate/edit', data, config)
    .then((res) => {
      console.log(res.data);
      Swal.fire({
        title: 'Governorate Updated',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getGovernorate());
      window.location.href = '#/governorate';
    })
    .catch((err) => console.log(err));
};

// AREA LIST
export const getArea = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/admin/country/listing', config)
    .then((res) => {
      dispatch({
        type: GET_AREA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};
export const getAreaById = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/country/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: SINGLE_AREA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};
//DELETE AREA
export const deleteArea = (data) => (dispatch) => {
  console.log(data);

  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    imageUrl: './assets/images/test.png',
    imageHeight: 100,
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((Confirm) => {
    if (Confirm.value) {
      axios
        .post(Constant.getAPI() + '/area/delete', data, config)
        .then((res) => {
          Swal.fire({
            title: 'Area Deleted',
            text: 'You will not be able to recover this !',
            type: 'warning',
            imageUrl: './assets/images/test.png',
            imageHeight: 100,
          });
          dispatch(getArea());
          window.location.href = '#/area';
        })
        .catch((err) => console.log(err));
    }
  });
};
//UPDATE AREA
export const updateArea = (data) => (dispatch) => {
  console.log(data);
  axios
    .put(Constant.getAPI() + '/admin/country/listing', data, config)
    .then((res) => {
      console.log(res.data);
      Swal.fire({
        title: 'Area Updated',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getArea());
      window.location.href = '#area';
    })
    .catch((err) => console.log(err));
};

//ADD AREA
export const addArea = (data) => (dispatch) => {
  console.log(data);
  axios
    .post(Constant.getAPI() + '/admin/country/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Area added',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getArea());
      window.location.href = '#/area';
    })
    .catch((err) => console.log(err));
};

//ADD TERMS
export const addTerms = (data) => (dispatch) => {
  console.log(config);
  axios
    .post(Constant.getAPI() + `/terms/add`, data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Terms added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch();
      window.location.href = '#/dateblock';
    })
    .catch((err) => console.log(err));
};
// GET TERMS
export const getTerms = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + '/terms/get', data)
    .then((res) => {
      dispatch({
        type: GET_TERMS,
        payload: res.data.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};
//GET SERVICE FILTER
export const GetServiceFilter = (serviceType) => (dispatch) => {
  console.log('>>>>', serviceType);
  axios

    .get(Constant.getAPI() + '/taxiOwner/listing', serviceType, config)

    .then((res) => {
      console.log('heeee<<<<', res);
      dispatch({
        type: GET_SERVICE_FILTER,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

//GET CAR BRAND

export const getCarBrand = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/admin/brand/listing', config)
    .then((res) => {
      dispatch({
        type: GET_CARBRAND_DATA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};
//GET CARS WITH BRAND FILTER

export const getCarsBrandFilter = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(
      Constant.getAPI() + `/admin/brand/carModel/listing?brandId=${data}`,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_CARBRAND_FILTER,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

//add car brand
export const AddCarBrand = (data) => (dispatch) => {
  console.log('this is add carbrand', data);
  axios
    .post(Constant.getAPI() + '/admin/brand/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Add Successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getCarBrand());
      window.location.href = '#/CarDetail/CarModel';
    })
    .catch((err) => console.log(err));
};

//GET CAR MODEL

export const getCarModel = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/admin/brand/carModel/listing', config)
    .then((res) => {
      dispatch({
        type: GET_CARMODEL_DATA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

//ADD CAR MODEL

export const addCarModel = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + '/admin/brand/carModel/listing', data, config)
    .then((res) => {
      console.log('resresresres', res);
      Swal.fire({
        title: 'Car Model Add Successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/CarModel';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

//UPDATE CAR MODEL

export const updateCarModel = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + '/admin/brand/carModel/listing', data, config)
    .then((res) => {
      console.log('resresresres', res);
      Swal.fire({
        title: 'Car Model Updated Successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/CarModel';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

//add ccar
export const AddCarUnderBrand = (data) => (dispatch) => {
  console.log('this is add carbrand', data);
  axios
    .post(Constant.getAPI() + '/admin/brand/carModel/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Add Successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getCarsBrandFilter());
      window.location.reload();
      // window.location.href = '#/CarDetail/CarModel';
    })
    .catch((err) => console.log(err));
};

//update ccar
export const UpdateCarUnderBrand = (data) => (dispatch) => {
  console.log('this is update carbrand', data);
  axios
    .put(Constant.getAPI() + '/admin/brand/carModel/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Updated Successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getCarsBrandFilter());
      window.location.reload();
      // window.location.href = '#/CarDetail/CarModel';
    })
    .catch((err) => console.log(err));
};

//Delete ccar
export const DeleteCarUnderBrand = (data) => (dispatch) => {
  console.log('this is add carbrand', data);
  axios
    .delete(
      Constant.getAPI() + `/admin/brand/carModel/listing?carModelId=${data}`,
      config
    )
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Car Delete Successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      // dispatch(getCarBrand());
      window.location.reload();
      window.location.href = '#/CarDetail/CarModel';
    })
    .catch((err) => console.log(err));
};

export const UpdateCarBrand = (data) => (dispatch) => {
  // console.log('this is add carbrand', data);
  axios
    .put(Constant.getAPI() + '/admin/brand/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Updated Successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getCarBrand());
      window.location.href = '#/CarDetail/CarBrand';
    })
    .catch((err) => console.log(err));
};

export const getSingleCarBrandDetail = (data) => (dispatch) => {
  // console.log('this is add carbrand', data);
  axios
    .get(Constant.getAPI() + `/admin/brand/listing?brandId=${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_CAR_BRAND,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

//get all parts
export const getAllParts = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/admin/part/listing', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_PARTS_DATA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};
//add parts
export const AddParts = (data) => (dispatch) => {
  console.log('this is add carbrand', data);
  axios
    .post(Constant.getAPI() + '/admin/part/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Spare Part Added',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location('#/SparePartMaster/SpareParts');
    })
    .catch((err) => console.log(err));
};
//update parts
export const updatePart = (data) => (dispatch) => {
  console.log('this is add carbrand', data);
  axios
    .put(Constant.getAPI() + '/admin/part/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Spare Part Updated',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/SparePartMaster/SpareParts';
    })
    .catch((err) => console.log(err));
};
// ADD PRODUCT PARTS
export const AddProductParts = (data) => (dispatch) => {
  console.log('this is add carbrand', data);
  axios
    .post(Constant.getAPI() + '/admin/part/product/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: ' added',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getCarBrand());
      window.location.href = '#/ProductMaster';
    })
    .catch((err) => console.log(err));
};

export const UpdateProductParts = (data) => (dispatch) => {
  console.log('this is add carbrand', data);
  axios
    .put(Constant.getAPI() + '/admin/part/product/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Updated',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getCarBrand());
      window.location.href = '#/ProductMaster';
    })
    .catch((err) => console.log(err));
};

//ADD PARTS

//GET ALL PRODUCT PARTS
export const getAllProductParts = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/admin/part/product/listing', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_PRODUCT_PARTS_DATA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleProductPart = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/part/listing?partId=${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_PRODUCT_PART_DATA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

//DELETE BUSINESS DATA

export const deleteBusinessId = (data) => (dispatch) => {
  console.log(data);

  let query = '';
  Object.keys(data).forEach((key) => {
    query += key + '=' + data[key].trim() + '&';
  });
  query = query.slice(0, -1);

  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    imageUrl: './assets/images/test.png',
    imageHeight: 100,
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((Confirm) => {
    if (Confirm.value) {
      axios
        .delete(
          Constant.getAPI() + `/garageOwner/listing` + '?' + query,
          config
        )
        .then((res) => {
          Swal.fire({
            title: 'Business id Deleted',
            text: 'You will not be able to recover this !',
            type: 'warning',
            imageUrl: './assets/images/test.png',
            imageHeight: 100,
          });
          // dispatch(getArea());
          // window.location.href = '#/area';
        })
        .catch((err) => console.log(err));
    }
  });
};

//GET GARAGE CATEGORY
export const getGarageCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/garageOwner/category/listing?all=1', config)
    .then((res) => {
      dispatch({
        type: GET_GARAGE_CATEGORY,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

//GET SINGLE GARAGE CATEGORY
export const getSingleGarage = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/garageOwner/category/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_GARAGE_CATEGORY,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

//UPDATE GARAGE CATEGORY
export const updateGarageCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + '/garageOwner/category/listing', data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_GARAGE_CATEGORY,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      // dispatch(getCarBrand());
      window.location.href = '#/BusinessCategoryMaster/GarageCategory';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

//ADD GARAGE CATEGORY
export const AddGaragecategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .post(Constant.getAPI() + '/garageOwner/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: ' Add successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      // dispatch(getCarBrand());
      window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    })
    .catch((err) => console.log(err));
};

//ADD SPARE PARTS CATEGORY
export const AddSparePartscategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .post(Constant.getAPI() + '/spareParts/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Add successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      // dispatch(getCarBrand());
      window.location.href = '#/BusinessCategoryMaster/SparePartsCategory';
    })
    .catch((err) => console.log(err));
};

//UPDATE SPARE PARTS CATEGORY
export const updateSparePartCatgegory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .put(Constant.getAPI() + '/spareParts/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      // dispatch(getCarBrand());
      window.location.href = '#/BusinessCategoryMaster/SparePartsCategory';
    })
    .catch((err) => console.log(err));
};

//GET SINGLE SPARE PART
export const getSingleSparePartCategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .get(Constant.getAPI() + `/spareParts/category/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_SPARE_PART_CATEGORY,
        payload: res.data,
      });
      console.log(res);
    })
    .catch((err) => console.log(err));
};

//ADD CAR DEALER CATEGORY
export const AddCarDealercategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .post(Constant.getAPI() + '/carDealer/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Add successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      // dispatch(getCarBrand());
      window.location.href = '#/BusinessCategoryMaster/CarDealersCategory';
    })
    .catch((err) => console.log(err));
};

//UPDATE CAR DEALER CATEGORY
export const UpdateCarDealercategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .put(Constant.getAPI() + '/carDealer/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      // dispatch(getCarBrand());
      window.location.href = '#/BusinessCategoryMaster/CarDealersCategory';
    })
    .catch((err) => console.log(err));
};

export const getSingleCarDealerCategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .get(Constant.getAPI() + `/carDealer/category/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_CAR_DEALER_CATEGORY,
        payload: res.data,
      });
      console.log(res);
    })
    .catch((err) => console.log(err));
};

//GET SPARE PARTS CATEGORY
export const getSparePartsCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/spareParts/category/listing?all=1', config)
    .then((res) => {
      dispatch({
        type: GET_SPARE_PART_CATEGORY,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

//GET CAR DEALER CATEGORY
export const getCarDealerCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/carDealer/category/listing?all=1', config)
    .then((res) => {
      dispatch({
        type: GET_CAR_DEALER_CATEGORY,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};
//ADMIN AREA ADD
export const AddAdminArea = (data) => (dispatch) => {
  console.log(data);
  axios
    .post(Constant.getAPI() + '/admin/area/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Area added',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(getArea());
      window.location.href = '#/SparePartMaster/CarArea';
    })
    .catch((err) => console.log(err));
};

export const getAdminArea = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/admin/area/listing', config)
    .then((res) => {
      dispatch({
        type: GET_ADMIN_AREA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getCarWashListing = () => (dispatch) => {
  // console.log('this is inside axios cardealer', data);

  axios
    .get(Constant.getAPI() + '/carWash/listing', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_BUSINESS_DATA_LIST,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSingleCarWash = (data) => (dispatch) => {
  // console.log('this is inside axios carwash', data);

  axios
    .get(Constant.getAPI() + `/carwash/listing?carWashId=${data}`, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      dispatch({
        type: GET_SINGLE_CAR_WASH,
        payload: res.data.response,
      });
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const updateCarWash = (data) => (dispatch) => {
  console.log('this is inside axios carwash', data);
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/carwash/listing`, data, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '#/ServiceProviders/CarWash';
    })
    .catch((err) => console.log(err));
};

export const getcarInsuranceListing = () => (dispatch) => {
  // console.log('this is inside axios cardealer', data);

  axios
    .get(Constant.getAPI() + '/carInsurance/listing', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_BUSINESS_DATA_LIST,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSingleCarInsurance = (data) => (dispatch) => {
  // console.log('this is inside axios carInsurance', data);

  axios
    .get(
      Constant.getAPI() + `/carInsurance/listing?carInsuranceId=${data}`,
      config
    )
    .then((res) => {
      console.log('78ad8a7d8', res);
      dispatch({
        type: GET_SINGLE_CAR_INSURANCE,
        payload: res.data.response,
      });
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const updateCarInsurance = (data) => (dispatch) => {
  console.log('this is inside axios carInsurance', data);
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/carInsurance/listing`, data, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '#/ServiceProviders/CarInsurance';
    })
    .catch((err) => console.log(err));
};

export const getdrivingSchoolListing = () => (dispatch) => {
  // console.log('this is inside axios cardealer', data);

  axios
    .get(Constant.getAPI() + '/drivingSchool/listing', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_BUSINESS_DATA_LIST,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSingleDrivingSchool = (data) => (dispatch) => {
  // console.log('this is inside axios carInsurance', data);

  axios
    .get(
      Constant.getAPI() + `/drivingSchool/listing?drivingSchoolId=${data}`,
      config
    )
    .then((res) => {
      console.log('78ad8a7d8', res);
      dispatch({
        type: GET_SINGLE_DRIVING_SCHOOL,
        payload: res.data.response,
      });
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const updateDrivingSchool = (data) => (dispatch) => {
  console.log('this is inside axios carInsurance', data);
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/drivingSchool/listing`, data, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '#/ServiceProviders/DrivingSchool';
    })
    .catch((err) => console.log(err));
};

export const getcarProtectionListing = () => (dispatch) => {
  // console.log('this is inside axios cardealer', data);

  axios
    .get(Constant.getAPI() + '/carProtection/listing', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_BUSINESS_DATA_LIST,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSingleCarProtection = (data) => (dispatch) => {
  // console.log('this is inside axios carInsurance', data);

  axios
    .get(
      Constant.getAPI() + `/carProtection/listing?carProtectionId=${data}`,
      config
    )
    .then((res) => {
      console.log('78ad8a7d8', res);
      dispatch({
        type: GET_SINGLE_CAR_PROTECTION,
        payload: res.data.response,
      });
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const updateCarProtection = (data) => (dispatch) => {
  console.log('this is inside axios carInsurance', data);
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/carProtection/listing`, data, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '#/ServiceProviders/CarProtection';
    })
    .catch((err) => console.log(err));
};

export const getairConditioningListing = () => (dispatch) => {
  // console.log('this is inside axios cardealer', data);

  axios
    .get(Constant.getAPI() + '/airConditioning/listing', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_BUSINESS_DATA_LIST,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSingleAirConditioning = (data) => (dispatch) => {
  // console.log('this is inside axios carInsurance', data);

  axios
    .get(
      Constant.getAPI() + `/airConditioning/listing?airConditioningId=${data}`,
      config
    )
    .then((res) => {
      console.log('78ad8a7d8', res);
      dispatch({
        type: GET_SINGLE_AIR_CONDITIONING,
        payload: res.data.response,
      });
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const updateAirConditioning = (data) => (dispatch) => {
  console.log('this is inside axios carInsurance', data);
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/airConditioning/listing`, data, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '#/ServiceProviders/CarConditioning';
    })
    .catch((err) => console.log(err));
};

// get quickServiceOwner List

export const getquickServiceOwnerListing = () => (dispatch) => {
  // console.log('this is inside axios cardealer', data);

  axios
    .get(Constant.getAPI() + '/quickServiceOwner/listing', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_BUSINESS_DATA_LIST,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const getSingleQuickServiceOwner = (data) => (dispatch) => {
  // console.log('this is inside axios carInsurance', data);

  axios
    .get(
      Constant.getAPI() +
        `/quickServiceOwner/listing?quickServiceOwnerId=${data}`,
      config
    )
    .then((res) => {
      console.log('78ad8a7d8', res);
      dispatch({
        type: GET_SINGLE_QUICK_SERVICE_OWNER,
        payload: res.data.response,
      });
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

export const updateQuickServiceOwner = (data) => (dispatch) => {
  console.log('this is inside axios carInsurance', data);
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/quickServiceOwner/listing`, data, config)
    .then((res) => {
      console.log('78ad8a7d8', res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '#/ServiceProviders/QuickService';
    })
    .catch((err) => console.log(err));
};

// get car wash category
export const getcarWashCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/carWash/category/listing?all=1', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_BUSINESS_CATEGORY,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.log(err);
      Swal.fire({
        title: 'Network Error!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
    });
};

// get car insurance category

export const getcarInsuranceCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/carInsurance/category/listing?all=1', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_BUSINESS_CATEGORY,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.log(err);
      Swal.fire({
        title: 'Network Error!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
    });
};

// get driving school category
export const getdrivingSchoolCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/drivingSchool/category/listing?all=1', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_BUSINESS_CATEGORY,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.log(err);
      Swal.fire({
        title: 'Network Error!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
    });
};

// get car protection category

export const getcarProtectionCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/carProtection/category/listing?all=1', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_BUSINESS_CATEGORY,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.log(err);
      Swal.fire({
        title: 'Network Error!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
    });
};

// get air conditioning category
export const getairConditioningCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/airConditioning/category/listing?all=1', config)
    .then((res) => {
      dispatch({
        type: GET_ALL_BUSINESS_CATEGORY,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => {
      console.log(err);
      Swal.fire({
        title: 'Network Error!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
    });
};

// add car wash category

export const AddcarWashcategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .post(Constant.getAPI() + '/carWash/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: ' Add successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      // dispatch(getCarBrand());
      window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    })
    .catch((err) => {
      console.log(err.response.data.response);
    });
};

// update car wash category

export const UpdateCarWashCategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .put(Constant.getAPI() + '/carWash/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      // dispatch(getCarBrand());
      window.location.href = '#/BusinessCategoryMaster/CarWashCategory';
    })
    .catch((err) => {
      console.log(err.response.data.response);
    });
};

export const getSingleCarWashCategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .get(Constant.getAPI() + `/carWash/category/get-one/${data}`, config)
    .then((res) => {
      console.log(res);
      dispatch({
        type: GET_SINGLE_CAR_WASH_CATEGORY,
        payload: res.data,
      });
      window.location.href = '#/BusinessCategoryMaster/CarWashCategory';
    })
    .catch((err) => {
      console.log(err.response.data.response);
    });
};

// add car insurance category

export const AddcarInsurancecategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .post(Constant.getAPI() + '/carInsurance/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: ' Add successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      // dispatch(getCarBrand());
      window.location.href = '#/BusinessCategoryMaster/CarInsuranceCategory';
    })
    .catch((err) => {
      // console.log(err.response.data.response);
      Swal.fire({
        title: err?.response?.data?.response?.category
          ? err?.response?.data?.response?.category
          : 'Network Error!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
    });
};

// update car insurance category

export const updateCarInsuranceCategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .put(Constant.getAPI() + '/carInsurance/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      // dispatch(getCarBrand());
      window.location.href = '#/BusinessCategoryMaster/CarInsuranceCategory';
    })
    .catch((err) => {
      console.log(err.response.data.response);
    });
};

export const getSingleCarInsuranceCategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .get(Constant.getAPI() + `/carInsurance/category/get-one/${data}`, config)
    .then((res) => {
      console.log(res);
      dispatch({
        type: GET_SINGLE_CAR_INSURANCE_CATEGORY,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err.response.data.response);
    });
};

// add drivingSchool category
export const AdddrivingSchoolcategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .post(Constant.getAPI() + '/drivingSchool/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Add successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });

      window.location.href = '#/BusinessCategoryMaster/DrivingSchoolCategory';
    })
    .catch((err) => {
      Swal.fire({
        title: err?.response?.data?.response?.category
          ? err?.response?.data?.response?.category
          : 'Network Error!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
    });
};

// get single drivingSchool category
export const getSingleDrivingSchoolCategory = (data) => (dispatch) => {
  axios
    .get(Constant.getAPI() + `/drivingSchool/category/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_DRIVING_SCHOOL_CATEGORY,
        payload: res.data,
      });
    })
    .catch((err) => console.log(err));
};

// update drivingSchool category
export const updateDrivingSchoolCategory = (data) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .put(Constant.getAPI() + '/drivingSchool/category/listing', data, config)
    .then((res) => {
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/BusinessCategoryMaster/DrivingSchoolCategory';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

//add carProtection category

export const AddcarProtectioncategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .post(Constant.getAPI() + '/carProtection/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Add successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });

      window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    })
    .catch((err) => {
      Swal.fire({
        title: err?.response?.data?.response?.category
          ? err?.response?.data?.response?.category
          : 'Network Error!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
    });
};

//update carProtection category

export const updateCarProtectionCategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .put(Constant.getAPI() + '/carProtection/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/BusinessCategoryMaster/CarProtectionCategory';
    })
    .catch((err) => {
      console.log(err.response.data.response);
    });
};

export const getSingleCarProtCategory = (data) => (dispatch) => {
  console.log('this is add cgarage category', data);
  axios
    .get(Constant.getAPI() + `/carProtection/category/get-one/${data}`, config)
    .then((res) => {
      console.log(res);
      dispatch({
        type: GET_SINGLE_CAR_PROTECTION_CATEGORY,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err.response.data.response);
    });
};

//Add airConditioning category

export const AddairConditioningcategory = (data) => (dispatch) => {
  axios
    .post(Constant.getAPI() + '/airConditioning/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Add successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });

      window.location.href = '#/BusinessCategoryMaster/GarageCategory';
    })
    .catch((err) => {
      // console.log(err.response.data.response);
      Swal.fire({
        title: err?.response?.data?.response?.category
          ? err?.response?.data?.response?.category
          : 'Network Error!!',
        icon: 'error',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
    });
};

//Upadte airConditioning category

export const UpdateAirConditionCategory = (data) => (dispatch) => {
  axios
    .put(Constant.getAPI() + '/airConditioning/category/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });

      window.location.href = '#/BusinessCategoryMaster/CarConditioningCategory';
    })
    .catch((err) => {
      console.log(err.response.data.response);
    });
};

export const getSingleCarConditionCategory = (data) => (dispatch) => {
  axios
    .get(
      Constant.getAPI() + `/airConditioning/category/get-one/${data}`,
      config
    )
    .then((res) => {
      console.log(res);
      dispatch({
        type: GET_SINGLE_AIR_CONDITION_CATEGORY,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err.response.data.response);
    });
};

export const getCarServices = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/admin/service/listing', config)
    .then((res) => {
      dispatch({
        type: GET_SERVICES_DATA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleCarService = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/service/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_SERVICES_DATA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const updateCarService = (data) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .put(Constant.getAPI() + '/admin/service/listing', data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_SERVICES_DATA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
      window.location.href = '/#/ServiceTypeMaster/CarService';
    })
    .catch((err) => console.log(err));
};

export const addCarService = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + `/admin/service`, data, config)
    .then((res) => {
      dispatch({
        type: ADD_CAR_SERVICES,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getquick = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/admin/quickService/listing', config)
    .then((res) => {
      dispatch({
        type: GET_SERVICES_DATA,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleQuickService = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + '/admin/quickService/listing', config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_QUICK_SERVICE,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addQuickService = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + `/admin/quickService/listing`, data, config)
    .then((res) => {
      dispatch({
        type: ADD_QUICK_SERVICES,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getPackagesList = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/advertisementPack/listing`, data, config)
    .then((res) => {
      dispatch({
        type: GET_PACKAGES_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addPackagesList = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + `/admin/advertisementPack/listing`, data, config)
    .then((res) => {
      dispatch({
        type: ADD_PACKAGES_LIST,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Package Added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '/#/Packages';
    })
    .catch((err) => console.log(err));
};

export const updatePackagesList = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/admin/advertisementPack/listing`, data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_PACKAGES_LIST,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Package Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      dispatch(setLoading(false));
      window.location.href = '/#/Packages';
    })
    .catch((err) => console.log(err));
};

export const deletePackagesList = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .delete(
      Constant.getAPI() +
        `/admin/advertisementPack/listing?advertisementPackId=${data}`,
      config
    )
    .then((res) => {
      // dispatch({
      // 	type: UPDATE_PACKAGES_LIST,
      // 	payload: res.data,
      // });
      console.log('deleteres', res);
      dispatch(setLoading(false));
      dispatch(getPackagesList());
    })
    .catch((err) => console.log(err));
};

export const getUserDetail = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/user?userId=${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_USER_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const updateUserProfile =
  (data, userType = 'user') =>
  (dispatch) => {
    dispatch(setLoading(true));

    axios
      .put(Constant.getAPI() + `/user/update-user-details`, data, config)
      .then((res) => {
        dispatch({
          type: UPDATE_USER_PROFILE,
          payload: res.data,
        });
        console.log(res);
        Swal.fire({
          title:
            userType === 'serviceProvider'
              ? 'Service Provider Updated'
              : 'User Updated',
          icon: '',
          imageUrl: './assets/images/test.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        });
        dispatch(setLoading(false));

        if (userType === 'serviceProvider')
          window.location.href = '/#/service-provider';
        else window.location.href = '/#/user';
      })
      .catch((err) => console.log(err));
  };

// UPDATE GARAGE LIST
export const UpdateGarageList = (data) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .put(Constant.getAPI() + '/garageOwner/listing', data, config)
    .then((res) => {
      console.log(res);
      Swal.fire({
        title: 'Garage Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/ServiceProviders/Garage';
      dispatch(getGarageData());
    })
    .catch((err) => console.log(err));
};

export const getGarageOwnerData = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(
      Constant.getAPI() + `/garageOwner/listing?garageOwnerId=${data}`,
      config
    )
    .then((res) => {
      dispatch({
        type: GET_SINGLE_GARAGE_OWNER,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleSparePart = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/spareParts/listing?sparePartsId=${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_SPARE_PART,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const updateSingleSparePart = (data) => (dispatch) => {
  dispatch(setLoading(true));
  console.log('this is inside axios', data);

  axios
    .put(Constant.getAPI() + `/spareParts/listing`, data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_SINGLE_SPARE_PART,
        payload: res.data,
      });
      Swal.fire({
        title: 'Updated successfully',
        type: 'success',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      console.log(res);
      dispatch(SparePartsGetList());
      window.location.href = '#/ServiceProviders/SpareParts';
    })
    .catch((err) => console.log(err));
};

export const getCountries = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/country/listing`, data, config)
    .then((res) => {
      dispatch({
        type: GET_COUNTRIES_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getCyclinderListing = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/cyclinder/listing`, data, config)
    .then((res) => {
      dispatch({
        type: GET_CYCLINDER_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleCyclinder = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/cyclinder/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_CYCLINDER_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getModelyearListing = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/modelYear/listing`, data, config)
    .then((res) => {
      dispatch({
        type: GET_MODEL_YEAR_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleModelyear = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/modelYear/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_MODEL_YEAR_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getFuelTypeList = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/fuelType/listing`, data, config)
    .then((res) => {
      dispatch({
        type: GET_FUEL_TYPE_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleFuelType = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/fuelType/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_FUEL_TYPE_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getDoorList = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/door/listing`, data, config)
    .then((res) => {
      dispatch({
        type: GET_DOOR_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addCylinder = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + `/admin/cyclinder/listing`, data, config)
    .then((res) => {
      dispatch({
        type: ADD_CYLINDER,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Cylinder Added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Cylinder';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const updateCylinder = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/admin/cyclinder/listing`, data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_CYLINDER,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Cyclinder Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Cylinder';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addModelYear = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + `/admin/modelYear/listing`, data, config)
    .then((res) => {
      dispatch({
        type: ADD_MODEL_YEAR,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Model Year Added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/modelYear';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const updateModelYear = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/admin/modelYear/listing`, data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_MODEL_YEAR,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Model Year Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/ModelYear';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addFuelType = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + `/admin/fuelType/listing`, data, config)
    .then((res) => {
      dispatch({
        type: ADD_FUEL_TYPE,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Fuel Type Added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/FuelType';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const updateFuelType = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/admin/fuelType/listing`, data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_FUEL_TYPE,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Fuel Type Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/FuelType';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addDoor = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + `/admin/door/listing`, data, config)
    .then((res) => {
      dispatch({
        type: ADD_DOOR_LIST,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Door Added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Doors';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const updateDoor = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/admin/door/listing`, data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_DOOR_LIST,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Door Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Doors';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleDoor = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/door/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_DOOR_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSeatsList = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/seat/listing`, data, config)
    .then((res) => {
      dispatch({
        type: GET_SEATS_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addSeat = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + `/admin/seat/listing`, data, config)
    .then((res) => {
      dispatch({
        type: ADD_SEAT_LIST,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Seat Added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Seats';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const updateSeat = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/admin/seat/listing`, data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_SEAT_LIST,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Seat Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Seats';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleSeat = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/seat/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_SEAT_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getColorList = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/color/listing`, data, config)
    .then((res) => {
      dispatch({
        type: GET_COLOR_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleColor = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/color/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_COLOR_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addColor = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + `/admin/color/listing`, data, config)
    .then((res) => {
      dispatch({
        type: ADD_COLOR_LIST,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Color Added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Color';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const updateColor = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/admin/color/listing`, data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_COLOR_LIST,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Color Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Color';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSafetyList = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/safety/listing`, data, config)
    .then((res) => {
      dispatch({
        type: GET_SAFETY_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addSafety = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + `/admin/safety/listing`, data, config)
    .then((res) => {
      dispatch({
        type: ADD_SAFETY_LIST,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Safety Added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Safety';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const updateSafety = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/admin/safety/listing`, data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_SAFETY_LIST,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Safety Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Safety';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleSafety = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/safety/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_SAFETY_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const updateComfert = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .put(Constant.getAPI() + `/admin/comfort/listing`, data, config)
    .then((res) => {
      dispatch({
        type: UPDATE_COMFORT,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Comfort Updated',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Comfort';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getComfortList = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/comfort/listing`, data, config)
    .then((res) => {
      dispatch({
        type: GET_COMFORT_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getSingleComfort = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .get(Constant.getAPI() + `/admin/comfort/get-one/${data}`, config)
    .then((res) => {
      dispatch({
        type: GET_SINGLE_COMFORT_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addComfort = (data) => (dispatch) => {
  dispatch(setLoading(true));

  axios
    .post(Constant.getAPI() + `/admin/comfort/listing`, data, config)
    .then((res) => {
      dispatch({
        type: ADD_COMFORT,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Comfort Added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/CarDetail/Comfort';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const getServiceProviderList = (data) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get(Constant.getAPI() + `/user?userType=serviceProvider`, config)
    .then((res) => {
      dispatch({
        type: GET_SERVICE_PROVIDER_LIST,
        payload: res.data,
      });
      console.log(res);
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addTermsCondition = (data) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post(
      Constant.getAPI() + `/admin/termsConditions/set-page-content`,
      data,
      config
    )
    .then((res) => {
      dispatch({
        type: ADD_TERMS_AND_CONDITION,
        payload: res.data,
      });
      console.log(res);
      Swal.fire({
        title: 'Terms Added',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/terms';
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

export const addNewNotification = (data) => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post(Constant.getAPI() + `/notification/send`, data, config)
    .then((res) => {
      dispatch({
        type: SEND_NOTIFICATION,
        payload: res.data,
      });
      console.log('Newres', res);
      Swal.fire({
        title: 'Notification Sent',
        icon: '',
        imageUrl: './assets/images/test.png',
        imageHeight: 100,
        text: '',
        type: 'success',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      });
      window.location.href = '#/notification';
      dispatch(setLoading(false));
    })
    .catch((err) =>
      // console.log(err.response.data.response.message),
      Swal.fire({
        title: 'Error',
        icon: 'error',
        // imageUrl: './assets/images/test.png',
        // imageHeight: 100,
        text: err.response.data.response.message,
        type: 'error',
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
    );
};

//
export const getContact = () => (dispatch) => {
  axios
    .get(Constant.getAPI() + '/admin/contactus/listing', config)
    .then((res) => {
      dispatch({
        type: CONTACT_LIST,
        payload: res.data.response,
      });
      console.log(res);
      dispatch(setLoading(true));
    })
    .catch((err) => console.log(err));
};

//
export const DeleteCarBrand = (data) => (dispatch) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .delete(
          Constant.getAPI() + `/admin/brand/listing?brandId=${data}`,
          config
        )
        .then((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'You will not be able to recover this !',
            //  imageUrl: "./assets/images/caviar.png",
            imageHeight: 100,
            type: 'warning',
          });
          window.location.reload();
          dispatch(getCategory());
        })
        .catch((err) => console.log(err));
    }
  });
};

export const DeleteCarModel = (data) => (dispatch) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .delete(
          Constant.getAPI() +
            `/admin/brand/carModel/listing?carModelId=${data}`,
          config
        )
        .then((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'You will not be able to recover this !',
            //  imageUrl: "./assets/images/caviar.png",
            imageHeight: 100,
            type: 'warning',
          });
          window.location.reload();
          //  dispatch( getCategory() );
        })
        .catch((err) => console.log(err));
    }
  });
};
// CYCLENDER DELETE
export const DeleteCarCylender = (data) => (dispatch) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .delete(
          Constant.getAPI() + `/admin/cyclinder/listing?cyclinderId=${data}`,
          config
        )
        .then((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'You will not be able to recover this !',
            //  imageUrl: "./assets/images/caviar.png",
            imageHeight: 100,
            type: 'warning',
          });
          window.location.reload();
          //  dispatch( getCategory() );
        })
        .catch((err) => console.log(err));
    }
  });
};

export const DeleteCarModelYear = (data) => (dispatch) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .delete(
          Constant.getAPI() + `/admin/modelYear/listing?modelYearId=${data}`,
          config
        )
        .then((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'You will not be able to recover this !',
            //  imageUrl: "./assets/images/caviar.png",
            imageHeight: 100,
            type: 'warning',
          });
          window.location.reload();
          //  dispatch( getCategory() );
        })
        .catch((err) => console.log(err));
    }
  });
};
// DELETE CARFURLTYPE
export const DeleteCarFuelType = (data) => (dispatch) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .delete(
          Constant.getAPI() + `/admin/fuelType/listing?fuelTypeId=${data}`,
          config
        )
        .then((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'You will not be able to recover this !',
            //  imageUrl: "./assets/images/caviar.png",
            imageHeight: 100,
            type: 'warning',
          });
          window.location.reload();
          //  dispatch( getCategory() );
        })
        .catch((err) => console.log(err));
    }
  });
};

// DELETE CAR DOOR
export const DeleteCarDoor = (data) => (dispatch) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .delete(
          Constant.getAPI() + `/admin/door/listing?doorId=${data}`,
          config
        )
        .then((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'You will not be able to recover this !',
            //  imageUrl: "./assets/images/caviar.png",
            imageHeight: 100,
            type: 'warning',
          });
          window.location.reload();
          //  dispatch( getCategory() );
        })
        .catch((err) => console.log(err));
    }
  });
};

// DELETE CAR SEAT
export const DeleteCarSeat = (data) => (dispatch) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .delete(
          Constant.getAPI() + `/admin/seat/listing?seatId=${data}`,
          config
        )
        .then((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'You will not be able to recover this !',
            //  imageUrl: "./assets/images/caviar.png",
            imageHeight: 100,
            type: 'warning',
          });
          window.location.reload();
          //  dispatch( getCategory() );
        })
        .catch((err) => console.log(err));
    }
  });
};

// DELETE CAR COLOR
export const DeleteCarColor = (data) => (dispatch) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .delete(
          Constant.getAPI() + `/admin/color/listing?colorId=${data}`,
          config
        )
        .then((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'You will not be able to recover this !',
            //  imageUrl: "./assets/images/caviar.png",
            imageHeight: 100,
            type: 'warning',
          });
          window.location.reload();
          //  dispatch( getCategory() );
        })
        .catch((err) => console.log(err));
    }
  });
};

// DLETE CAR SAFETY
export const DeleteCarSafety = (data) => (dispatch) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .delete(
          Constant.getAPI() + `/admin/safety/listing?safetyId=${data}`,
          config
        )
        .then((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'You will not be able to recover this !',
            //  imageUrl: "./assets/images/caviar.png",
            imageHeight: 100,
            type: 'warning',
          });
          window.location.reload();
          //  dispatch( getCategory() );
        })
        .catch((err) => console.log(err));
    }
  });
};

// DELETE  CAR COMFORT
export const DeleteCarComfort = (data) => (dispatch) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this !',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then((isConfirm) => {
    if (isConfirm.value) {
      axios
        .delete(
          Constant.getAPI() + `/admin/comfort/listing?comfortId=${data}`,
          config
        )
        .then((res) => {
          Swal.fire({
            title: 'Deleted!',
            text: 'You will not be able to recover this !',
            //  imageUrl: "./assets/images/caviar.png",
            imageHeight: 100,
            type: 'warning',
          });
          window.location.reload();
          //  dispatch( getCategory() );
        })
        .catch((err) => console.log(err));
    }
  });
};

export const getDateWisePayments = () => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get(
      Constant.getAPI() +
        '/payment/get-subscription-orders?freeNotIncluded=true',
      config
    )
    .then((res) => {
      dispatch({
        type: GET_DATEWISE_ORDER,
        payload: res.data.data,
      });
      dispatch(setLoading(false));
    })
    .catch((err) => console.log(err));
};

// ---- Admin profile-view (user / service-provider) data ----
export const getProfileUser = (userId) => (dispatch) => {
  axios
    .get(Constant.getAPI() + `/user?userId=${userId}`, config)
    .then((res) => dispatch({ type: 'GET_PROFILE_USER', payload: res.data }))
    .catch((err) => console.log(err));
};

export const getUserSubscriptionHistory = (userId) => (dispatch) => {
  axios
    .get(Constant.getAPI() + `/payment/get-subscription-orders?userId=${userId}`, config)
    .then((res) => dispatch({ type: 'GET_USER_SUBS', payload: res.data }))
    .catch((err) => console.log(err));
};

export const getUserCarPosts = (userId) => (dispatch) => {
  axios
    .get(Constant.getAPI() + `/carSale/listing?userId=${userId}`, config)
    .then((res) => dispatch({ type: 'GET_USER_CARPOSTS', payload: res.data }))
    .catch((err) => console.log(err));
};

export const getListingStats = (businessId) => (dispatch) => {
  axios
    .get(Constant.getAPI() + `/listing-view/stats?businessId=${businessId}`, config)
    .then((res) => dispatch({ type: 'GET_LISTING_STATS', payload: res.data }))
    .catch((err) => console.log(err));
};

export const adminSetPassword = (userId, newPassword, onDone) => (dispatch) => {
  axios
    .post(Constant.getAPI() + '/user/admin-set-password', { userId, newPassword }, config)
    .then(() => {
      if (typeof onDone === 'function') onDone();
    })
    .catch((err) => {
      Swal.fire({
        title: err?.response?.data?.response?.message || 'Could not update password',
        icon: 'error',
        confirmButtonColor: '#3ab1f7',
      });
    });
};

// Admin: toggle a garage's active/inactive status (lightweight, status-only).
export const updateGarageStatus = (garageOwnerId, status) => (dispatch) => {
  axios
    .put(Constant.getAPI() + '/garageOwner/status', { garageOwnerId, status }, config)
    .then(() => {
      dispatch(getGarageData());
    })
    .catch((err) => {
      Swal.fire({
        title: 'Could not update status. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3ab1f7',
      });
    });
};

// Admin: generic active/inactive toggle for ANY service-provider category.
// Refetches the right list after updating so the row reflects immediately.
export const updateBusinessStatus = (type, businessId, status, refetch) => (dispatch) => {
  axios
    .put(Constant.getAPI() + '/admin/business-status/update', { type, businessId, status }, config)
    .then(() => {
      if (typeof refetch === 'function') refetch();
    })
    .catch((err) => {
      Swal.fire({
        title: 'Could not update status. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3ab1f7',
      });
    });
};

// Admin: delete a car-for-sale post.
export const deleteCarSale = (carSaleId, onDone) => (dispatch) => {
  axios
    .delete(Constant.getAPI() + '/carSale/listing', {
      headers: config.headers,
      data: { carSaleId },
    })
    .then(() => {
      Swal.fire({ title: 'Car post deleted', icon: 'success', confirmButtonColor: '#3ab1f7' });
      if (typeof onDone === 'function') onDone();
    })
    .catch((err) => {
      Swal.fire({ title: 'Could not delete. Please try again.', icon: 'error', confirmButtonColor: '#3ab1f7' });
    });
};

// Admin: lightweight update of a car-for-sale post's simple fields.
export const updateCarSaleAdmin = (data, onDone) => (dispatch) => {
  axios
    .put(Constant.getAPI() + '/carSale/admin-update', data, config)
    .then(() => {
      Swal.fire({ title: 'Saved', icon: 'success', confirmButtonColor: '#3ab1f7' });
      if (typeof onDone === 'function') onDone();
    })
    .catch((err) => {
      Swal.fire({ title: 'Could not save. Please try again.', icon: 'error', confirmButtonColor: '#3ab1f7' });
    });
};

// Admin: fetch the plans available for a business's category (to assign/extend).
export const getPlansForBusiness = (businessId) => (dispatch) => {
  axios
    .get(Constant.getAPI() + `/payment/admin-plans-for-business?businessId=${businessId}`, config)
    .then((res) => dispatch({ type: 'GET_PLANS_FOR_BUSINESS', payload: res.data }))
    .catch((err) => console.log(err));
};

// Admin: assign / extend a plan for a business (extends from current expiry).
export const adminAssignPlan = (businessId, paymentPlan, onDone) => (dispatch) => {
  axios
    .post(Constant.getAPI() + '/payment/admin-assign-plan', { businessId, paymentPlan }, config)
    .then(() => {
      Swal.fire({ title: 'Plan assigned successfully', icon: 'success', confirmButtonColor: '#3ab1f7' });
      if (typeof onDone === 'function') onDone();
    })
    .catch((err) => {
      Swal.fire({
        title: err?.response?.data?.response?.message || 'Could not assign plan. Please try again.',
        icon: 'error',
        confirmButtonColor: '#3ab1f7',
      });
    });
};
